import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';

const Header = ({ galleryInfo, siteSettings }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Our Work', path: '/our-work' },
    { name: 'About Us', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header className="sticky top-0 z-40 bg-gray-900 shadow-md text-white">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 md:px-6 lg:px-8 flex justify-between items-center h-16 sm:h-20 md:h-24">
        
        {/* Logo Section */}
        <Link 
          to="/" 
          className="flex items-center gap-1.5 sm:gap-3 hover:opacity-80 transition-opacity flex-shrink-0"
        >
          {galleryInfo && galleryInfo.logoUrl ? (
            <img 
              className="h-16 sm:h-16 md:h-20 w-16 sm:w-16 md:w-20 object-contain" 
              src={galleryInfo.logoUrl} 
              alt="Kolinsky Art Gallery Logo"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          ) : (
            <div className="h-16 sm:h-16 md:h-20 w-16 sm:w-16 md:w-20 bg-orange-500 rounded-full flex-shrink-0"></div>
          )}
          <span className="text-xs sm:text-sm md:text-lg lg:text-xl font-black text-white tracking-tight hidden sm:inline">
            Kolinsky Art Gallery
          </span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-4 lg:gap-8">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className="text-xs lg:text-base text-gray-300 hover:text-orange-400 font-medium transition relative group"
            >
              {item.name}
              <span className="absolute bottom-0 left-0 w-full h-0.5 bg-orange-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
            </Link>
          ))}
          <a
            href={siteSettings.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="px-3 lg:px-4 py-1.5 lg:py-2 bg-green-500 text-white text-xs lg:text-base rounded-full hover:bg-green-600 transition font-medium whitespace-nowrap"
          >
            WhatsApp Us
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-orange-500 p-1"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-gray-800 border-t border-gray-700 max-h-[calc(100vh-64px)] overflow-y-auto">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className="block w-full text-left px-4 py-3 sm:py-4 text-xs sm:text-base text-gray-200 hover:bg-gray-700 hover:text-orange-400 font-medium border-b border-gray-700 last:border-b-0"
              >
                {item.name}
              </Link>
            ))}
          </nav>
          <div className="p-3 sm:p-4 border-t border-gray-700">
            <a
              href={siteSettings.whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full text-center py-2.5 sm:py-3 bg-green-500 text-white text-xs sm:text-base rounded-full hover:bg-green-600 font-medium"
            >
              WhatsApp Us
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;